interface ProfileHeroProps {
  outfitsCount: number;
  favouritesCount: number;
}

export default function ProfileHero({ outfitsCount, favouritesCount }: ProfileHeroProps) {
  return (
    <div className="relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-r from-pink-500/10 via-purple-500/10 to-indigo-500/10 dark:from-pink-500/5 dark:via-purple-500/5 dark:to-indigo-500/5"></div>
      <div className="relative px-6 py-16 sm:px-8 lg:px-12">
        <div className="mx-auto max-w-7xl">
          <div className="text-center">
            <h1 className="text-4xl font-extralight tracking-[0.4em] uppercase text-gray-900 dark:text-white sm:text-5xl lg:text-6xl">
              ATELIER
            </h1>
            <p className="mt-4 text-lg font-light tracking-wider text-gray-600 dark:text-gray-300">
              Your Personal Style Sanctuary
            </p>
            <div className="mt-8 flex items-center justify-center space-x-8 text-sm font-light tracking-wider text-gray-500 dark:text-gray-400">
              <div className="flex items-center space-x-2">
                <div className="h-2 w-2 rounded-full bg-gradient-to-r from-pink-500 to-purple-500"></div>
                <span>{outfitsCount} OUTFITS CURATED</span>
              </div>
              <div className="flex items-center space-x-2">
                <div className="h-2 w-2 rounded-full bg-gradient-to-r from-purple-500 to-indigo-500"></div>
                <span>{favouritesCount} FAVOURITES</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}